import Api from '@/services/Api'

export default {
  newSession (params) {
    return Api().post('fmc/new_session', params)
  },
  startSession (params) {
    return Api().post('fmc/start_session', params)
  },
  
  submitMove (params) {
    return Api().post('fmc/submit_move', params)
  },
  
  submitResult (params) {
    return Api().post('fmc/submit_result', params)
  },
}
